import React from 'react';
import { NavLink } from 'react-router-dom';
import './Menu.css';

const Menu: React.FC = () => {
  return (
    <div className="menu-container">
      <NavLink
        to="/dashboard"
        className={({ isActive }) => `menu-item ${isActive ? 'active' : ''}`}
      >
        Portfolioübersicht
      </NavLink>
      <NavLink
        to="/properties"
        className={({ isActive }) => `menu-item ${isActive ? 'active' : ''}`}
      >
        Meine Immobilien
      </NavLink>
    </div>
  );
};

export default Menu;
